module.exports = __webpack_public_path__ + "static/img/male.badfc002.png";